module.exports = __webpack_public_path__ + "img/success.e887b045.svg";